import CopyJobDialog from './CopyJobDialog';
import { useGetJobQuery } from '../../api/jobs/GetJobQuery';
import CopyJobDialogProps from './CopyJobDialogProps';

type CopyJobDialogWrapperProps = Omit<CopyJobDialogProps, 'job'> & {
  selectedId: string;
};

const CopyJobDialogWrapper = ({
  selectedId,
  ...rest
}: CopyJobDialogWrapperProps) => {
  const job = useGetJobQuery(selectedId);
  return <CopyJobDialog job={job} {...rest} />;
};

export default CopyJobDialogWrapper;
